import React, { useState } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useSendInviteMutation } from '../slices/invitationApiSlice';

const InviteModal = ({ show, onHide, leagueId, leagueName, onInviteSent }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const [sendInvite, { isLoading }] = useSendInviteMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      await sendInvite({
        leagueId,
        invitedEmail: email,
      }).unwrap();

      toast.success(`Invitation sent to ${email}!`);
      setEmail('');
      onHide();
      if (onInviteSent) onInviteSent();
    } catch (err) {
      setError(err.data?.message || err.message || 'Failed to send invitation');
    }
  };

  const handleClose = () => {
    setEmail('');
    setError('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Invite to {leagueName}</Modal.Title>
      </Modal.Header>
      
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && (
            <Alert variant="danger" className="mb-3">
              {error}
            </Alert>
          )}
          
          <Form.Group className="mb-3">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email address"
              required
              disabled={isLoading}
            />
            <Form.Text className="text-muted">
              An invitation email will be sent to this address.
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isLoading || !email.trim()}>
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Sending...
              </>
            ) : (
              'Send Invitation'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default InviteModal;
